<template>
  <div class="topbar" :class="{ 'white-background': isWhiteBackground }">
    <div class="topbar-breadcrumbs">
      <slot name="breadcrumbs" />
    </div>
    <div class="topbar-page-title">
      <slot name="page-title" />
    </div>
    <div class="topbar-summaries">
      <slot name="summaries" />
    </div>
    <div class="topbar-actions">
      <slot name="topbar-actions" />
    </div>
  </div>
</template>

<script setup>
defineProps({
  isWhiteBackground: { type: Boolean, default: false },
});
</script>

<style lang="less" scoped>
.topbar {
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: repeat(2, auto) 16px auto;
  padding: 24px 24px 16px 24px;
  position: sticky;
  top: -60px;
  z-index: 3;
  background-color: @bg-canvas;

  &.white-background {
    background-color: @white;
  }
}

.topbar-breadcrumbs {
  grid-row: 1;
  grid-column: 1;
}

.topbar-page-title {
  grid-row: 2;
  grid-column: 1;
  max-width: 100%;
  overflow-x: hidden;
}

.topbar-summaries {
  grid-row: 1 / 3;
  grid-column: 2;
  align-self: end;
  justify-self: end;
}

.topbar-actions {
  grid-row: 4;
  grid-column: 1 / 3;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
}
</style>
